<template>
  <v-container grid-list-xl fluid>
    <v-container class="ma-0 pa-0" fluid>
      <v-container grid-list-xs fluid style="padding: 0px;">
        <v-layout row style="padding: 0px;">
          <!-- Dialog for Add View Edit -->
          <v-flex md6>
            <v-form ref="form">
              <v-text-field
                ref="form"
                class="mr-1"
                prepend-icon="search"
                label="Search by Card No."
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-form>
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn fab dark small color="amber darken-2" @click="playData()">
            <v-icon dark>play_arrow</v-icon>
          </v-btn>

          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="refreshData()"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadExcel()"
            >
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                />
              </svg>
            </v-btn>
            <span>Download Excel File</span>
          </v-tooltip>
        </v-layout>

        <v-container grid-list-lg fluid style="padding: 0px;" class="mt-3">
          <v-layout>
            <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                lazy
                :disabled="queryParams.search ? true : false"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  :disabled="queryParams.search ? true : false"
                  v-model="dateFrom"
                  label="Date From"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  v-model="dateFrom"
                  :max="dateTo"
                  min="1950-01-01"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex md2 style="padding: 0 5px;">
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                lazy
                :disabled="queryParams.search ? true : false"
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  :disabled="queryParams.search ? true : false"
                  v-model="dateTo"
                  label="Date To"
                  prepend-inner-icon="event"
                  outline
                  readonly
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  v-model="dateTo"
                  :max="new Date().toISOString().substr(0, 10)"
                  :min="dateFrom"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
      <v-divider></v-divider>
      <jti-filter-panel :title="title">
        <v-flex md4>
          <v-combobox
            v-model="filterItem_Branch"
            :items="filterItem_Branches"
            label="Branch"
            chips
            clearable
            multiple
            @change="onChangeComboboxBranch"
          >
            <template v-slot:selection="data">
              <v-chip :selected="data.selected" @input="remove(data.item)">
                <strong wrap>{{ data.item.text }}</strong
                >&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-flex>
        <v-flex md4>
          <v-combobox
            v-model="statusFilterItem"
            :items="statusFilterItems"
            label="Status"
            chips
            clearable
            multiple
            @change="onChangeComboboxStatus"
          >
            <template v-slot:selection="data">
              <v-chip :selected="data.selected" @input="remove(data.item)">
                <strong wrap>{{ data.item.text }}</strong
                >&nbsp;
              </v-chip>
            </template>
          </v-combobox>
        </v-flex>
      </jti-filter-panel>
      <bottom-scroll @on-bottom="loadMore" :offset="queryParams.offset">
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  header.value === queryParams.order ? 'active' : '',
                  'text-xs-' + header.align,
                ]"
              >
                <span>{{ header.text }}</span>
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.index + 1 }}</td>
            <td class="text-xs-left text-no-wrap">
              {{ props.item.date ? props.item.date : "--" }}
            </td>
            <td class="text-xs-left text-no-wrap">
              {{ props.item.time ? props.item.time : "--" }}
            </td>
            <td class="text-xs-left text-no-wrap">
              {{ props.item.device_no ? props.item.device_no : "--" }}
            </td>
            <td class="text-xs-left text-no-wrap">
              {{ props.item.branch ? props.item.branch.toUpperCase() : "--" }}
            </td>
            <td class="text-xs-left text-no-wrap">
              {{ props.item.card_no ? props.item.card_no : "--" }}
            </td>
            <td class="text-xs-left text-no-wrap">
              {{
                props.item.amount
                  ? $amountInPeso(props.item.amount)
                  : $amountInPeso(0)
              }}
            </td>
            <td class="text-xs-left text-no-wrap">
              {{
                props.item.b_a_name ? props.item.b_a_name.toUpperCase() : "--"
              }}
            </td>
             <td class="text-xs-left text-no-wrap">
              {{
                props.item.transaction_type ? props.item.transaction_type.toUpperCase() : "--"
              }}
            </td>

            <td class="text-xs-left text-no-wrap">
              {{
                props.item.status_error_code ? props.item.status_error_code.toUpperCase() : "--"
              }}
            </td>

            <td class="text-xs-center">
              <v-tooltip top>
                <v-btn
                  v-if="props.item.recon_status == 0"
                  icon
                  small
                  slot="activator"
                  style="height: 16px; width: 15px;"
                  @click="openDialog(props.item.id)"
                >
                  <v-hover v-slot="{ hover }">
                    <v-icon medium :color="hover ? '#040e63' : 'blue'"
                      >find_in_page</v-icon
                    >
                  </v-hover>
                </v-btn>
                <span>View</span>
              </v-tooltip>
              <h4
                v-if="props.item.recon_status == 2"
                style="color:#556B2F; text-align:center"
              >
                RECONCILED
              </h4>
              <h4
                v-if="props.item.recon_status == 1"
                style="color:#8B0000; text-align:center"
              >
                DECLINED
              </h4>
            </td>
          </template>
        </v-data-table>
      </bottom-scroll>

      <accept-decline-dialog
        :type="dialogType"
        :title="title"
        :dialog="dialogStatus"
        @closeDialog="closeDialog"
        @accept="Recon()"
        @decline="Decline()"
        @openConfirmDialog="openConfirmTransactionDialog"
        :loading="dialogLoading"
      >
        <v-container grid-list-xs>
          <v-layout justify-center>
            <v-flex md12>
              <!-- Insert View Dialog Content BELOW-->
              <details-container
                ref="detailsRef"
                :data="null"
                :transId="transId"
                :items="viewItems"
                :headers="containerHeaders"
                :readOnly="dialogType === 'view'"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </accept-decline-dialog>

      <message-dialog
        :dialog="openConfirmDialog"
        :title="reconConfirmDialogTitle"
        :message="reconConfirmDialogMessage"
        @save="confirmTransaction"
        @close="closeConfirmDialog"
        :loading="confirmLoading"
      ></message-dialog>
    </v-container>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import XLSX from "xlsx";
import DetailsContainer from "@/components/details_container/ReconDetailsContainer.vue";
var now = new Date();

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      reconConfirmDialogTitle: "",
      reconConfirmDialogMessage: "",
      reconStatus: 0,
      transId: null,
      openConfirmDialog: false,
      confirmLoading: false,

      clockMode: "",
      openFilter: false,
      timeOut: null,
      dateFromMenu: false,
      dateToMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",
      heightMap: "",
      widthMap: "",
      mapDialog: false,
      center: { lat: 14.4793, lng: 121.0198 },
      zoom: 20,
      title: "Recon",
      items: [],
      containerHeaders: [
        {
          text: "#",
          align: "center",
          value: "#",
          sortable: false,
        },
        {
          text: "Transaction / Ticket No.",
          align: "center",
          value: "transaction_ticket_no",
          sortable: false,
        },
        {
          text: "Application",
          align: "center",
          value: "app",
          sortable: false,
        },
        {
          text: "Card No.",
          align: "center",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Date",
          align: "center",
          value: "date",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          value: "time",
          sortable: false,
        },
        {
          text: "Transaction Type",
          align: "center",
          value: "ticket_type",
          sortable: false,
        },
        {
          text: "Previous Balance",
          align: "center",
          value: "prev_bal",
          sortable: false,
        },
        {
          text: "Amount",
          align: "center",
          value: "amount",
          sortable: false,
        },
        {
          text: "Remaining Balance",
          align: "center",
          value: "rem_bal",
          sortable: false,
        },
      ],
      headers: [
        { text: "#", align: "center", sortable: false },
        {
          text: "Date",
          align: "center",
          value: "date",
          sortable: false,
        },
        {
          text: "Time",
          align: "center",
          value: "time",
          sortable: false,
        },
        {
          text: "Device Number",
          align: "center",
          value: "device_number",
          sortable: false,
        },
        {
          text: "Branch",
          align: "center",
          value: "branch",
          sortable: false,
        },
        {
          text: "Card Number",
          align: "center",
          value: "card_number",
          sortable: false,
        },
        {
          text: "Amount",
          align: "center",
          value: "amount",
          sortable: false,
        },
        {
          text: "B.A. Name",
          align: "center",
          value: "b_a_name",
          sortable: false,
        },
        {
          text: "Transaction type",
          align: "center",
          value: "transaction_type",
          sortable: false,
        },
        {
          text: "Error Code",
          align: "center",
          value: "status_error_code",
          sortable: false,
        },
        {
          text: "Action / Status",
          align: "center",
          value: "action_status",
          sortable: false,
        },
      ],
      filterItem_Branches: [],
      filterItem_Branch: [],
      statusFilterItems: [
        { text: "OPEN", value: 0 },
        { text: "DECLINED", value: 1 },
        { text: "RECONCILED", value: 2 },
      ],
      statusFilterItem: [],
      queryParams: {
        search: null,
        offset: 0,
        limit: 100,
        branch: [],
        date_from: null,
        date_to: null,
        status: [],
      },
      totalItems: 0,
      show: false,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      viewItems: [],
      menu: false,
      menu1: false,
      date_from: this.$dateFormat(now, "YYYY-MM-DD"),
      date_to: this.$dateFormat(now, "YYYY-MM-DD"),
      play_status: false,
    };
  },
  beforeDestroy() {
    window.stop();
  },
  watch: {
    dateFrom: async function() {
      this.resetTable();

      if (
        this.dateFrom !== null &&
        this.dateFrom !== undefined &&
        this.dateFrom !== ""
      ) {
        this.queryParams.offset = 0;
        this.dateFrom = this.queryParams.date_from;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.date_from = null;
      }
    },
    dateTo: async function() {
      this.resetTable();

      if (
        this.dateTo !== null &&
        this.dateTo !== undefined &&
        this.dateTo !== ""
      ) {
        this.queryParams.offset = 0;
        this.dateTo = this.queryParams.date_to;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.date_to = null;
      }
    },
  },
  created: async function() {
    await this.$store.commit("initiateTempData");
    this.resetTable();
    this.getProjectTerminal();
  },
  computed: {
    computedItems() {
      return this.$store.state.tempData;
    },
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
    dateFrom: {
      get() {
        this.queryParams.date_from = this.date_from;
        return this.date_from;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_from = value;
        this.date_from = value;
      },
    },
    dateTo: {
      get() {
        this.queryParams.date_to = this.date_to;
        return this.date_to;
      },
      set(value) {
        this.resetTable();
        this.queryParams.date_to = value;
        this.date_to = value;
      },
    },
  },
  methods: {
    async openDialog(id) {
      await Promise.all(
        (this.dialogType = "edit"),
        (this.transId = id),
        await this.setData(id),
        (this.dialogStatus = true)
      );
    },
    async setData(id) {
      this.$store.dispatch("startLoading");
      try {
        const response = (await Services.getReconTransChecklist(id)).data;

        if (response) {
          this.viewItems = response.data;
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.$store.dispatch("endLoading");
    },
    async getProjectTerminal() {
      this.filterItem_Branches = [];

      let terminals = await Services.getTerminalList();

      await terminals.data.data.map((item) => {
        this.filterItem_Branches.push({
          text: item.name.toUpperCase(),
          value: item.name.toLowerCase(),
        });
      });
    },
    async onChangeComboboxBranch(items) {
      this.filterItem_Branch = items.filter((item) =>
        this.filterItem_Branches.includes(item)
      );
    },
    async onChangeComboboxStatus(items) {
      this.statusFilterItem = items.filter((item) =>
        this.statusFilterItems.includes(item)
      );
    },
    selectAllRoutes() {
      this.filterItem_Branch = [...this.filterItem_Branch];
    },
    remove(item) {
      this.filterItem_Branch.splice(this.filterItem_Branch.indexOf(item), 1);
      this.filterItem_Branch = [...this.filterItem_Branch];
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async Recon() {
      await this.openConfirmTransactionDialog("Recon", 2);
    },
    async Decline() {
      await this.openConfirmTransactionDialog("Decline", 1);
    },
    async openConfirmTransactionDialog(title, reconStatus) {
      this.reconConfirmDialogTitle = this.$capitalizeFirstLetter(title);
      this.reconStatus = reconStatus;
      this.openConfirmDialog = true;

      this.reconConfirmDialogMessage =
        (await reconStatus) == 1
          ? "Are you sure you want to Decline this transaction?"
          : "Are you sure you want to Reconcile this transaction?";
    },
    async confirmTransaction() {
      this.$store.dispatch("startLoading");
      const body = { recon_status: this.reconStatus };

      try {
        this.confirmLoading = true;
        const result = await Services.updateReconTransaction(
          this.transId,
          body
        );
        await this.closeDialog();
        await this.$infoBar({
          type: "success",
          text:
            (await this.reconStatus) == 1
              ? "Decline Transaction Success"
              : "Reconcile Transaction Success",
        });
        await this.playData();
        this.confirmLoading = false;
        this.openConfirmDialog = false;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
        this.confirmLoading = false;
      }
      this.$store.dispatch("endLoading");
    },
    search(data) {
      this.resetTable();
      this.queryParams.search = data;

      this.queryParams.date_from = data ? null : this.date_from;
      this.queryParams.date_to = data ? null : this.date_to;
    },
    async getData() {
      await this.$store.dispatch("startLoading");
      this.queryParams.branch = [];
      this.queryParams.status = [];

      await this.filterItem_Branch.map((item) => {
        this.queryParams.branch.push(item.value);
      });
      await this.statusFilterItem.map((item) => {
        this.queryParams.status.push(item.value);
      });
      try {
        const response = (await Services.ReconTransactions(this.queryParams))
          .data;
        // Assign the reponse data to items to be display on table
        this.items = this.items.concat(response.data);

        this.totalItems = response.count;

        // await this.setFilterItems();
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }

      this.$store.dispatch("endLoading");
    },
    async getReportData(){
      try {
        const response = (await Services.ReconTransactions({...this.queryParams, limit: Number.MAX_SAFE_INTEGER}))
          .data;
          return response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }

      return [];
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;

      await this.getProjectTerminal();
    },
    async playData() {
      this.items = [];

      this.resetTable();

      this.play_status = true;
      this.getData();
    },
    refreshData() {
      this.date_from = this.$dateFormat(now, "YYYY-MM-DD");
      this.date_to = this.$dateFormat(now, "YYYY-MM-DD");
      this.$refs.form.reset();
      this.filterTransaction = null;
      this.items = [];

      this.resetTable();
    },
    resetTable() {
      this.queryParams.limit = 100;
      this.queryParams.offset = 0;

      this.play_status = false;
    },
    async loadMore() {
      if (!this.play_status) return;

      this.queryParams.offset += this.queryParams.limit;

      if (this.queryParams.offset >= this.totalItems) return;

      await this.getData();
    },
    cancelTimePicker() {
      if (this.clockMode === "timeFrom") {
        this.timeFrom = "00:00";
        this.timeFromMenu = false;
      }
      if (this.clockMode === "timeTo") {
        this.timeTo = "23:59";
        this.timeToMenu = false;
      }
    },
    closeDialog() {
      this.dialogType = "";

      this.dialogStatus = false;
    },
    async downloadExcel() {
      let items = await this.getReportData();

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text);
      }
      await header.shift();
      await header.pop();
      header.push("Status");
      dataToDownload.push(header);
      //
      for (let e = 0; e < items.length; e++) {
        let theItem = [];

        theItem.push(items[e].date ? items[e].date : "--");
        theItem.push(items[e].time ? items[e].time : "--");
        theItem.push(items[e].device_no ? items[e].device_no : "--");
        theItem.push(items[e].branch ? items[e].branch.toUpperCase() : "--");
        theItem.push(items[e].card_no ? items[e].card_no : "--");
        theItem.push(items[e].amount ? items[e].amount : "--");
        theItem.push(
          items[e].b_a_name ? items[e].b_a_name.toUpperCase() : "--"
        );
        theItem.push(
          items[e].transaction_type ? items[e].transaction_type.toUpperCase() : "--"
        );
        theItem.push(
          items[e].status_error_code ? items[e].status_error_code.toUpperCase() : "--"
        );
        theItem.push(
          items[e].recon_status != 0
            ? items[e].recon_status == 1
              ? "Declined"
              : "Reconciled"
            : "--"
        );
        dataToDownload.push(theItem);
      }
      this.$store.dispatch("endLoading");

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped>
#viewTable {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#viewTable td,
#viewTable th {
  border: 2px solid #000;
  padding: 8px;
}

.propertyName {
  background-color: rgb(241, 241, 241);
  font-weight: bold;
}

.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.form {
  padding: 0px 5px 10px 5px;
  border: 2px solid gray;
  border-radius: 5px;
}
.form:hover {
  border: 2px solid black;
}
#styled-input {
  height: 10px !important;
  font-size: 10pt !important;
}
</style>
